import {setupFrontend} from '@shared-frontend/setup_frontend';

import {App} from '@src/components/app';
import {theme} from '@src/components/theme';

setupFrontend({appComponent: App, theme});
// startFetchingAnalyticsWebsites();
